var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.69613e-05 15.5273C-0.0127108 18.7328 2.57554 21.3417 5.78107 21.3545C7.25734 21.3603 8.68042 20.8034 9.76056 19.7971L18.4099 23.7023C18.3498 24.0257 18.3169 24.3535 18.3113 24.6824C18.3011 27.91 20.9093 30.5347 24.1369 30.5449C27.3645 30.5552 29.9892 27.947 29.9994 24.7194C30.0096 21.4918 27.4014 18.8671 24.1738 18.8568C22.2455 18.8507 20.4383 19.7963 19.3438 21.3839L11.2175 17.7146C11.7947 16.3209 11.7969 14.7554 11.2238 13.36L19.3388 9.67198C21.1662 12.3149 24.79 12.976 27.4329 11.1486C30.0758 9.32126 30.7368 5.69747 28.9095 3.05456C27.0821 0.411659 23.4583 -0.249404 20.8154 1.57794C19.2414 2.66621 18.3033 4.4588 18.3063 6.37234C18.3115 6.70171 18.345 7.02995 18.4062 7.35364L9.77928 11.2738C7.44198 9.07904 3.76804 9.19462 1.57329 11.5319C0.557526 12.6138 -0.00545409 14.0434 4.69613e-05 15.5273Z",
    fill: "#00504E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share_.83555c07c71b5104cbc72b1d86223631.svg";
export { ForwardRef as ReactComponent };